<div class="topbar">
  <ul class="topbar__list">
    @if ($canSeeAutomatedTransfersNotificationsOverlay()) {
      <li>
        <osp-automated-transfers-notifications-center-overlay />
      </li>
    }

    @if ($canSeeAttention()) {
      <li>
        <osp-equipment-attention-overlay />
      </li>
    }
    @if ($canSeeNotifications()) {
      <li>
        <osp-notifications-center-overlay />
      </li>
    }
    <li>
      <osp-help-overlay />
    </li>

    <li>
      <osp-whitelabeled-component
        [componentKey]="WhitelabeledComponentKey.APP_SWITCHER"
        [defaultComponent]="ComponentPlaceholderComponent"
      />
    </li>

    <li>
      <osp-whitelabeled-component
        [componentKey]="WhitelabeledComponentKey.USER_SETTINGS_MENU"
        [defaultComponent]="UserSettingsMenuComponent"
      />
    </li>
  </ul>
</div>
